/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoadmapPlanSegmentDto
 */
export interface RoadmapPlanSegmentDto {
    /**
     * 
     * @type {string}
     * @memberof RoadmapPlanSegmentDto
     */
    planId?: string;
    /**
     * 
     * @type {string}
     * @memberof RoadmapPlanSegmentDto
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof RoadmapPlanSegmentDto
     */
    barStart?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RoadmapPlanSegmentDto
     */
    barEnd?: Date;
    /**
     * 
     * @type {number}
     * @memberof RoadmapPlanSegmentDto
     */
    budgetTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof RoadmapPlanSegmentDto
     */
    budgetSpent?: number;
    /**
     * 
     * @type {string}
     * @memberof RoadmapPlanSegmentDto
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof RoadmapPlanSegmentDto
     */
    tasksLinkedToMilestones?: number;
}

/**
 * Check if a given object implements the RoadmapPlanSegmentDto interface.
 */
export function instanceOfRoadmapPlanSegmentDto(value: object): value is RoadmapPlanSegmentDto {
    return true;
}

export function RoadmapPlanSegmentDtoFromJSON(json: any): RoadmapPlanSegmentDto {
    return RoadmapPlanSegmentDtoFromJSONTyped(json, false);
}

export function RoadmapPlanSegmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoadmapPlanSegmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'planId': json['planId'] == null ? undefined : json['planId'],
        'name': json['name'] == null ? undefined : json['name'],
        'barStart': json['barStart'] == null ? undefined : (new Date(json['barStart'])),
        'barEnd': json['barEnd'] == null ? undefined : (new Date(json['barEnd'])),
        'budgetTotal': json['budgetTotal'] == null ? undefined : json['budgetTotal'],
        'budgetSpent': json['budgetSpent'] == null ? undefined : json['budgetSpent'],
        'status': json['status'] == null ? undefined : json['status'],
        'tasksLinkedToMilestones': json['tasksLinkedToMilestones'] == null ? undefined : json['tasksLinkedToMilestones'],
    };
}

export function RoadmapPlanSegmentDtoToJSON(json: any): RoadmapPlanSegmentDto {
    return RoadmapPlanSegmentDtoToJSONTyped(json, false);
}

export function RoadmapPlanSegmentDtoToJSONTyped(value?: RoadmapPlanSegmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'planId': value['planId'],
        'name': value['name'],
        'barStart': value['barStart'] == null ? undefined : ((value['barStart']).toISOString().substring(0,10)),
        'barEnd': value['barEnd'] == null ? undefined : ((value['barEnd']).toISOString().substring(0,10)),
        'budgetTotal': value['budgetTotal'],
        'budgetSpent': value['budgetSpent'],
        'status': value['status'],
        'tasksLinkedToMilestones': value['tasksLinkedToMilestones'],
    };
}

